export default "__VITE_ASSET__Dv38YMtc__"